import axios from "axios";
import React from "react";

const api = axios.create({
   baseURL: "https://slrpackapi.oriolinfotech.com/",
  // baseURL: "http://localhost:5007/",
});

const imageapi = "https://slrpackapi.oriolinfotech.com/";
// const imageapi = "http://localhost:5007/";

export default api;
export { imageapi };
